import { getWeekStartsOn } from './getWeekStartsOn'
import { transcodingUnavailable } from './transcodingUnavailable'

export const environment = {
  getWeekStartsOn,
  transcodingUnavailable,
}
